module.exports = __webpack_public_path__ + "img/anonyma_icon.727b7aac.svg";